// src/data/colors.js

export const COLORS = [
  {
    slug: "satin-black",
    name: "Satin Black",
    brand: "UL Wraps",
    finish: "Satin",
    family: "Black",
    thumb: "/assets/colors/satin-black.jpg",
    image: "/assets/colors/satin-black.jpg",
    description: "Timeless stealth. Our most popular finish for full color changes.",
    basePrice: 899, // base price for 60\" x 50ft
    widths: ['60"', '72"'],
    lengths: ["50 ft", "75 ft"],
  },
  {
    slug: "gloss-nardo-grey",
    name: "Gloss Nardo Grey",
    brand: "UL Wraps",
    finish: "Gloss",
    family: "Grey",
    thumb: "/assets/colors/gloss-nardo-grey.jpg",
    image: "/assets/colors/gloss-nardo-grey.jpg",
    description: "OEM+ grey with a deep gloss finish that looks factory if you know, you know.",
    basePrice: 949,
    widths: ['60"'],
    lengths: ["50 ft", "75 ft"],
  },
  {
    slug: "satin-khaki-green",
    name: "Satin Khaki Green",
    brand: "UL Wraps",
    finish: "Satin",
    family: "Green",
    thumb: "/assets/colors/satin-khaki-green.jpg",
    image: "/assets/colors/satin-khaki-green.jpg",
    description: "Military-inspired satin that makes SUVs and coupes look properly mean.",
    basePrice: 999,
    widths: ['60"'],
    lengths: ["50 ft", "75 ft"],
  },
  {
    slug: "gloss-frozen-blue",
    name: "Gloss Frozen Blue",
    brand: "UL Wraps",
    finish: "Gloss",
    family: "Blue",
    thumb: "/assets/colors/gloss-frozen-blue.jpg",
    image: "/assets/colors/gloss-frozen-blue.jpg",
    description: "Bright blue with serious pop for builds that live on camera.",
    basePrice: 999,
    widths: ['60"'],
    lengths: ["50 ft", "75 ft"],
  },
];

export function getColorBySlug(slug) {
  return COLORS.find((c) => c.slug === slug);
}
